import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, lastValueFrom, map, Observable, of } from "rxjs";
import { API_ENDPOINTS } from "../constants/api-endpoints";
import { ApiService } from "./api.service";
import { Router } from "@angular/router";

@Injectable({ providedIn: 'root' })
export class AccountManagementService extends ApiService   {
    constructor( http: HttpClient,  router: Router) {
        super(http, router);
    }

    getAccountList(companyId: string, userId: string): Observable<any> {
        const url = API_ENDPOINTS.ACCOUNT_MANAGEMENT.CONTROLLER + API_ENDPOINTS.ACCOUNT_MANAGEMENT.GET_ACCOUNT_LIST + `?companyId=${companyId}&userId=${userId}`;
        return this.http.get(url, {})
            .pipe(
                catchError(err => of(err)),
                map((response: any) => {
                    if (response) {
                        return response;
                    }
                    return null;
                }));
    }

    getUserRole(userId: string, companyId: string): Observable<any> {
        const url = API_ENDPOINTS.ACCOUNT_MANAGEMENT.CONTROLLER + API_ENDPOINTS.ACCOUNT_MANAGEMENT.GET_USER_ROLE + `?userId=${userId}&companyId=${companyId}`;
        return this.http.get(url, {})
            .pipe(
                catchError(err => of(err)),
                map((response: any) => {
                    if (response) {
                        return response;
                    }
                    return null;
                }));
    }

    saveRole(request:any) {
        const url = API_ENDPOINTS.ACCOUNT_MANAGEMENT.CONTROLLER + API_ENDPOINTS.ACCOUNT_MANAGEMENT.SAVE_ROLE;
        return this.http.post(url, request)
            .pipe(
                catchError(err => of(err)),
                map((response: any) => {
                    return response;
                }));    
    }

    deleteAccount(request:any) {
        const url = API_ENDPOINTS.ACCOUNT_MANAGEMENT.CONTROLLER + API_ENDPOINTS.ACCOUNT_MANAGEMENT.DELETE_ACCOUNT;
        return this.http.post(url, request)
            .pipe(
                catchError(err => of(err)),
                map((response: any) => {
                    return response;
                }));
    }

    
}